import styled from 'styled-components';

import Button from 'web-components/Button';

import {
  Flex,
  Text,
} from 'web-styled';

export const Checkout = styled(Flex).attrs({
  column: true,
  flex: '1 1 100%',
  spacing: 10,
})`
  margin: -25px;
  padding: 25px;

  hr {
    border-bottom: 1px solid #c2c2c2;
  }
`;

export const Item = styled(Flex).attrs({
  column: true,
  width: '100%',
})`
  padding: 17px 0;
  border-bottom: 1px solid #888888;

  &:first-of-type {
    border-top: 1px solid #888888;
  }
`;

export const RemoveItem = styled(Text).attrs({
  as: 'div',
  color: '#b64135',
})`
  font-size: 13px;
  cursor: pointer;
`;

export const LinkButton = styled(Button).attrs({
  appearance: 'link',
})`
  color: ${props => props.theme.colors.primary} !important;
  font-size: 15px;
  font-weight: 300;
`;
